import APIKit from "../Allapis/Apikit/apikit";


export const sendDocuseal = async(id)=>{
    const res = await APIKit.get(`/requests/${id}`)
    return res.data
  }